import React from "react";
import {Container, Col, Form, Row, Button, Table, Modal} from "react-bootstrap";
import {MdDeleteForever} from "react-icons/md";
import {FaEdit} from "react-icons/fa";
import * as constants from "Constants";
import httpService from 'services/httpService.js';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';

// This component serves as the 'Issue Header' component in both the list of issues screen and the issue screen
// The difference of behavior, as of now, is only what happens when we click on the issue
// The isIssuesScreen in props acts as the identifier 
class Issue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            issue: null,
            load: false,
            editMode: false,
            canUpdateIssue: false,
            canDeleteIssue: false,
        };
    }

    // When the parent component re-renders, new props are received here
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ 
            issue: nextProps.item
        });
    }

    componentDidMount() {
        this.setState({
            issue: this.props.item,
            status_names: this.props.status_names,
            canUpdateIssue: this.props.canUpdateIssue,
            canDeleteIssue: this.props.canDeleteIssue,
            load: true
        })
    }

    // Takes the status and returns long form
    getFullStatusName(status) {
        for(var i=0, n=this.state.status_names.length; i<n; i++) {
            if(status === this.state.status_names[i]["key"]) {
                return this.state.status_names[i]["value"]
            }
        }
    }

    getUsername(item) {
        return item.first_name + " " + item.last_name;
    }

    updateIssue = async (e) => {
        // Prevents default click behavior of the browser which is refresh in case of firefox
        e.preventDefault();
        // Stops propagation of onclick to parents
        e.stopPropagation();
    
        let form_data = new FormData();
        form_data.append("description", e.target.Description.value);
    
        const url = constants.base_url + "issues/updateIssue/" + this.state.issue.id;
    
        try {
            const response = await httpService.put(url, form_data);
            this.setState({
                editMode: false,
            });
            this.props.updateIssue(response.data.issue);
        } catch (error) {
            displayGlobalMessage(error.response.data.errorMsg, "error");
        }
    }

    markResolved = async (e) => {
        // Stops propagation of onclick to parents
        e.stopPropagation();
        let form_data = new FormData();
        form_data.append("status", "RES");
    
        const url = constants.base_url + "issues/updateStatus/" + this.state.issue.id;
    
        try {
            const response = await httpService.put(url, form_data);
            this.props.updateIssue(response.data.issue);
            // this.setState({
            //     issue: response.data.issue
            // })
        } catch (error) {
            displayGlobalMessage(error.response.data.errorMsg, "error");
        }
    }

    isIssueResolved() {
        return this.state.issue.status !== "RES" ? false : true;
    }

    parseDate = (str_date) => {
		return new Date(Date.parse(str_date)).toLocaleString();
		//return $.datepicker.formatDate("yyyy-mm-dd hh:mm:ss", new Date());
		//return new Date(Date.parse(str_date)).toISOString().split('T');
	};

    deleteIssue = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(confirm("Are you sure you want to delete the Issue?")) {
            this.props.deleteIssue(this.state.issue.id);
        }
        
    }

    toggleEditMode = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            editMode: true
        });
    }

    openIssue = () => {
        this.props.history.push({
            pathname: "issue/" + this.state.issue.id,
            state: {
                status_names: this.props.status_names
            }
        })
    }

    render() {
        if(this.state.load === false) {
            return (<div></div>)
        }

        var item = this.state.issue;
        return (
            <Container xs={12} 
                       style={styles.formboxContainer}
                       onClick = {(e) => {
                            e.preventDefault();
                            if(this.props.isIssuesScreen) {
                                this.openIssue();
                            }
                        }}
            >
                <Modal
                    show={this.state.editMode}
                    dialogClassName="modal-90w"
                    onHide={() => {
                        this.setState({ editMode: false });
                    }}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    onClick={(e) => { // IMPORTANT and REQUIRED since onClick() is propagated along with onSubmit in the form
                        e.stopPropagation();
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Edit Issue
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={(e) => this.updateIssue(e)}>
                            <Form.Group className="mb-3" controlId="Title">
                                <Form.Label>Title</Form.Label>
                                <Form.Control type="text" placeholder={item.title} disabled/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="Description">
                                <Form.Label>Description</Form.Label>
                                <Form.Control as="textarea" rows={3} defaultValue={item.description}/>
                            </Form.Group>
                            <Button type="submit" variant="primary">Update</Button>
                        </Form>

                    </Modal.Body>
                </Modal>

                <Form>
                    <div className="shadow" style={styles.formbox}>
                        <Col style={styles.formheaderbox}>
                        <Table borderless style={{marginBottom: 0}}>
                            <tbody>
                                <tr>
                                    <td style={{padding: 0}} width={"90%"}>
                                        <h4 className="panel-title panel-title-df">
                                            <span style={{fontSize: 20, wordBreak: 'break-word'}}>
                                                <strong>
                                                    {item.title}
                                                </strong>
                                            </span>
                                            <br/>
                                            <ul style={styles.issueMetaInfo} key="metainfo">
                                                <li key="username">Posted by - {this.getUsername(item.created_by)}</li>
                                                <li key="postedTime">{this.parseDate(item.created_at)}</li>
                                            </ul>
                                        </h4>
                                    </td>

                                    <td width={"5%"} style={{verticalAlign: "middle"}}>
                                        {
                                            this.isIssueResolved() === false && this.state.canUpdateIssue
                                            ?
                                                <div className="float-right" onClick={(e) => this.toggleEditMode(e)}>                            
                                                    <FaEdit size={25} />
                                                </div>
                                            :
                                                <div></div>
                                        }
                                        
                                    </td>

                                    <td width={"5%"} style={{verticalAlign: "middle"}}>
                                        {
                                            this.state.canDeleteIssue
                                            ?
                                                <div className="float-right" onClick={(e) => this.deleteIssue(e)}>                            
                                                    <MdDeleteForever size={28} />
                                                </div>
                                            :
                                            <div></div>
                                        }
                                    </td>
                                    
                                </tr>
                            </tbody>
                        </Table>
                        </Col>

                        <Table borderless>
                            <tbody>
                                <tr>
                                    <td width={"80%"}>
                                        <Form.Group as={Row}>
                                            <Form.Label as={Col} style={{wordBreak: 'break-word', whiteSpace: 'pre-wrap'}}>{item.description}</Form.Label>
                                        </Form.Group>
                                    </td>

                                    <td width={"20%"}>
                                        {/* status */}
                                        <Button
                                            variant="success"
                                            className="create-issue"
                                            onClick={(e) => {e.stopPropagation();}}
                                            style={{marginBottom: 6}}
                                        >
                                            {this.getFullStatusName(item.status)}
                                        </Button>
                                        {
                                            this.state.issue.status !== "RES" ? 
                                                <Button
                                                    variant="primary"
                                                    className="create-issue"
                                                    onClick={(e) => this.markResolved(e)}
                                                    disabled = {this.state.issue.status === "RES"}
                                                >
                                                    {this.state.issue.status === "RES" ? "Resolved" : "Click to Resolve"}
                                                </Button>
                                            :
                                                    <div></div>
                                        }
                                    </td>
                                </tr>
                                
                                <tr>
                                    <td style={{paddingBottom: 0, fontSize: 13, color: "#3e3e3e"}}>
                                        <span>
                                            <em>
                                                last modified: {this.parseDate(item.updated_at)}
                                            </em>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>

                    </div>
                </Form>
            </Container>
        );
    }
}

const styles = {
    formboxContainer: {
        marginLeft: 5,
        marginRight: 5,
        marginTop: 15,
        marginBottom: 15,
        cursor: "pointer",
        paddingRight: 0, 
        paddingLeft: 0
    },

    formbox: {
        border: "1px solid #ccc",
        width: '100%'
    },

    formheaderbox: {
        backgroundColor: "#eee",
        paddingTop: 5,
        paddingBottom: 5,
    },

    issueMetaInfo: {
        paddingTop: 8,
        paddingLeft: 0,
        fontSize: 15,
        listStyleType: 'none',
        color: "#636363"
    }
};

export default (Issue);